export const styleSheet = {
    position: "relative",
    display: "block",
    fontSize: ".875rem",
    fontWeight: 400,
    color: "#3e3e3e",
    marginBottom: "10px"
}